import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {PipelineConfigJsonSpec} from 'pipelines/StepShapeUtils';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import makeUseGlobalClientState from 'ui-library/hooks/global-client-state/makeUseGlobalClientState';
import {TabContainer, Tab} from 'ui-library/TabContainer';
import {JSONValue} from 'util/Types';

import {TabbedUISchema} from '../step-config-settings/StepConfigUISchemas';
import {TAB_ORDER_UI_SCHEMA_KEY} from '../StepConfigEditorTypes';
import StepConfigEditorRouterV2 from './StepConfigEditorRouterV2';

export interface StepConfigFormTabContainerProps {
  clientStateId: string;
  uiSchema: TabbedUISchema;
  config: Record<string, JSONValue>;
  onChangeConfig: (config: JSONValue, path: Array<string>, newValue: JSONValue) => void;
  configShape: PipelineConfigJsonSpec;
  dataTestAttrs?: Pick<DataTestAttrs, 'key' | 'index'>;
  disabled?: boolean;
}

const tabContainerState = makeUseGlobalClientState<string | null>(null);

export default function StepConfigFormTabContainer({
  clientStateId,
  uiSchema,
  config,
  onChangeConfig,
  configShape,
  dataTestAttrs,
  disabled,
}: StepConfigFormTabContainerProps): JSX.Element {
  const [maybeActiveTab, setActiveTab] = tabContainerState.useGlobalClientState(clientStateId);

  const activeTab = maybeActiveTab ?? uiSchema[TAB_ORDER_UI_SCHEMA_KEY][0];

  return (
    <TabContainer
      activeTab={activeTab}
      onRequestTabChange={setActiveTab}
      paneClassName={css(styles.tabContainerPane)}
      centerNavItem={true}
    >
      {uiSchema[TAB_ORDER_UI_SCHEMA_KEY].map((tabKey: string) => (
        <Tab key={tabKey} tabKey={tabKey} title={uiSchema[tabKey].displayName}>
          <StepConfigEditorRouterV2
            uiSchema={uiSchema[tabKey].uiSchema}
            config={config}
            onChangeConfig={onChangeConfig}
            configShape={configShape}
            dataTestAttrs={dataTestAttrs}
            disabled={disabled}
          />
        </Tab>
      ))}
    </TabContainer>
  );
}

const styles = StyleSheet.create({
  tabContainerPane: {
    marginTop: 15,
  },
});
